import BaseDrawerFeature from '@src/framework/workbench/common/feature/base-drawer-feature';
import type { IChartModel } from '@src/slide/domain/ui-model/element-modeles/Interface/chart-v3/chart-model.interface';

export default class ChartBaseDrawerFeature extends BaseDrawerFeature {
    /**
     * 获取当前选中元素
     */
    public getSelectModel() {
        return super.getSelectModel() as IChartModel;
    }
}
